{
  "AI-Added": "AI-Added",
  "Appointment Time": "Appointment Time",
  "Appointment Type": "Appointment Type",
  "By {{actorUserName}}": "By {{actorUserName}}",
  "Calendar": "Calendar",
  "Canceled": "Canceled",
  "Created": "Created",
  "Current Status": "Current Status",
  "Direct Booked": "Direct Booked",
  "Event": "Event",
  "Other": "Other",
  "PMS Added": "PMS Added",
  "Patient": "Patient",
  "Patient Added": "Patient Added",
  "Refresh Data": "Refresh Data",
  "Requested": "Requested",
  "Rescheduled": "Rescheduled",
  "Schedule Activity": "Schedule Activity",
  "Schedule an appointment to begin building your practice history.": "Schedule an appointment to begin building your practice history.",
  "Service": "Service",
  "Source": "Source",
  "Staff Added": "Staff Added",
  "Time": "Time",
  "Via Schedule Request": "Via Schedule Request",
  "Via Waitlist": "Via Waitlist",
  "Via online scheduling": "Via online scheduling",
  "Your schedule activity is empty": "Your schedule activity is empty"
}
